import React, { HTMLAttributes } from 'react';
import classNames from 'classnames';
import { NavLink } from 'react-router-dom';

interface MediumPillProps extends HTMLAttributes<HTMLDivElement> {
  Icon: React.FC<{ className?: string }>;
  title: string;
  to?: string;
}

export function MediumPill({
  children,
  Icon,
  title,
  onClick,
  to,
  ...props
}: MediumPillProps) {
  const Component = to ? NavLink : 'div';
  return (
    <Component
      {...(props as any)}
      to={to}
      className={classNames(
        `w-full xl:w-1/2 border-4 border-white h-12 rounded-lg flex items-center overflow-hidden`,
        'text-gray-500 bg-gray-100',
        to &&
          'cursor-pointer focus:bg-jcap-100 focus:text-jcap-500 hover:bg-gray-200 hover:text-gray-600',
        props.className,
      )}
    >
      <Icon className="flex-shrink-0 inline w-4 h-4 mx-3 pointer-events-none" />
      <div className="flex flex-col flex-grow pr-1 overflow-x-hidden truncate pointer-events-none select-none">
        <p className="text-xs font-semibold truncate">{title}</p>
      </div>
      {children}
    </Component>
  );
}

export default MediumPill;
